import React, { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import * as Yup from "yup";
import { BasicForm } from "@components/shared";
import { useTranslation } from "react-i18next";
export default function ArtistForm({
  id = null,
  name = "",
  onSuccess = () => {},
  isCuration,
}) {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  function onSubmit(formData) {
    setLoading(true);

    onUpdate(formData);
  }

  function onUpdate(formData) {
    const req = {
      artists: [
        {
          ...formData,
          artist_id: id,
        },
      ],
    };

    axios
      .put(`/artists/${id}/`, req)
      .then(() => setLoading(false))
      .then(() => toast.success(t("common:updated") + "!"))
      .then(() => onSuccess())
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  const fields = [
    {
      name: "name",
      label: t("common:name"),
      initialValue: name,
      required: true,
      schema: () =>
        Yup.string()
          .max(100, t("validation:too_long"))
          .required(t("validation:required")),
    },
  ];

  return (
    <BasicForm
      loading={loading}
      onSubmit={onSubmit}
      fields={fields}
      buttonProps={{
        // fullWidth: isCuration ? true : false,
        fullWidth: true,
      }}
    />
  );
}
